import script from "./RestaurantsList.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantsList.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantsList.vue?vue&type=style&index=0&id=474aab28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474aab28"]])

export default __exports__